import { render, staticRenderFns } from "./FluxRegaloWizard.vue?vue&type=template&id=7589bb94"
import script from "./FluxRegaloWizard.vue?vue&type=script&lang=js"
export * from "./FluxRegaloWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports